import type { CardCandidate } from './types'

// Suggestions only: neither OCR text nor a seller title proves an exact printing.
export function readSportsMetadata(text: string): Partial<CardCandidate> {
  const manufacturer = text.match(/\b(Upper Deck|Topps|Bowman|Fleer|Donruss|Panini|O-Pee-Chee|Score|Leaf|Pacific)\b/i)?.[1]
  const grading = text.match(/\b(PSA|BGS|BVG|SGC|CGC|CSG)\s*(?:GEM\s*(?:MINT|MT)|MINT|NM[- ]?MT|EX[- ]?MT|EX|VG[- ]?EX|VG|GOOD|FAIR|PRISTINE)?\s*(10|[1-9](?:\.5)?)\b/i)
  const company = grading?.[1] ?? text.match(/\b(PSA|BGS|BVG|SGC|CGC|CSG)\b/i)?.[1]
  const sport = text.match(/\b(baseball|basketball|football|hockey|soccer|golf|tennis|racing|wrestling|boxing|mma)\b/i)?.[1]
  return {
    releaseYear: text.match(/\b((?:19|20)\d{2})(?:[-/]\d{2,4})?\b/)?.[0] ?? '',
    manufacturer: manufacturer ?? '',
    collectorNumber: text.match(/(?:#|\b(?:card\s*(?:no\.?|number)|no\.)\s*)\s*([A-Z0-9]+(?:-[A-Z0-9]+)*)\b/i)?.[1] ?? '',
    gradingCompany: company?.toUpperCase() ?? '',
    grade: grading?.[2] ?? '',
    certificationNumber: text.match(/\bcert(?:ification)?(?:\s*(?:no\.?|number))?\s*[:#]?\s*(\d{6,12})\b/i)?.[1] ?? '',
    sport: sport ? sport[0].toUpperCase() + sport.slice(1).toLowerCase() : 'Sports',
  }
}

export function sportsSearchTerms(text: string): string[] {
  const lines = Array.from(new Set(text.split(/\r?\n/).map(line => line.trim().replace(/\s+/g, ' ')).filter(Boolean)))
  const names = lines.filter(line =>
    /^[A-Za-zÀ-ž.'’ -]{5,70}$/.test(line) && line.split(/\s+/).length >= 2 &&
    !/\b(upper deck|gem|mint|cert|authentic|trading|copyright|professional|guaranteed|baseball|basketball|football|hockey)\b/i.test(line),
  )
  const metadata = readSportsMetadata(text)
  const detail = [metadata.releaseYear, metadata.manufacturer, metadata.collectorNumber ? `#${metadata.collectorNumber}` : ''].filter(Boolean).join(' ')
  return Array.from(new Set([
    names[0] ? [names[0], detail].filter(Boolean).join(' ') : '',
    ...names,
    detail,
  ].filter(value => value.length >= 3))).slice(0, 5)
}
